import { __extends } from "tslib";
import { deserializeAws_restJson1_1UpdateSmsChannelCommand, serializeAws_restJson1_1UpdateSmsChannelCommand } from "../protocols/Aws_restJson1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var UpdateSmsChannelCommand = /** @class */ (function (_super) {
    __extends(UpdateSmsChannelCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function UpdateSmsChannelCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    UpdateSmsChannelCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {}
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    UpdateSmsChannelCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1_1UpdateSmsChannelCommand(input, context);
    };
    UpdateSmsChannelCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1_1UpdateSmsChannelCommand(output, context);
    };
    return UpdateSmsChannelCommand;
}($Command));
export { UpdateSmsChannelCommand };
//# sourceMappingURL=UpdateSmsChannelCommand.js.map